//CSS
import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { Link } from "react-router-dom";

//Data
// import VdoCipherComp from "../../Components/VdoCipher/VdoCipher";
import YouTubeVideo from "../../Components/VideoComp/YouTubeVideo";
import ModelViewerComp from "../../Components/3DComp/3Dcomp";

const CADDesigns: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Elf-Tech™ CAD Designs" />

            {/* <ModelViewerComp/> */}
            <SubSection isSplit={false}>
                <div className="inv-items">
                    <div className="inv-item">
                        <h4 className="inv-item-title">Value adding CADs for engines, parts, & subassemblies, using new tech and new tools.</h4>
                        <ul>
                            <li>Our E-SPEC software shows optimal engine geometries and how new parts and systems can be used.</li>
                            <li>The design team turns the E- SPEC reports into working three-dimensional engine and parts models.</li>
                            <li>Detailed CAD drawings (along with CAMs, blueprints & instructions) are available to purchase alone or along with licenses for producing ELF-Tech products.</li>
                        </ul>
                    </div>
                </div>
            </SubSection>
            <SubSection>
                <YouTubeVideo videoId="https://youtu.be/fLIM84lmHx4" />
            </SubSection>
            {/* <SubSection>
                <VdoCipherComp filename="dragonfly" title="Elf-Tech Dragonfly" />
            </SubSection> */}
            {/* <SubSection>
                <VdoCipherComp filename="eta4k"/>
            </SubSection> */}
        </div>
    );
};

export default CADDesigns;
